import { Box, Container, Typography } from "@mui/material";

import HomeIcon from "@mui/icons-material/Home";
import WeekendIcon from "@mui/icons-material/Weekend";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import DesignServicesIcon from "@mui/icons-material/DesignServices";

import specialtyBg from "../../assets/images/specialty_pricing_bg.png";
import specialtyBgm from "../../assets/images/specialty_pricing_bg_m.png";
import specialtyCardBg from "../../assets/images/specialty_pricing_card_bg.png";
import ContentCutIcon from "@mui/icons-material/ContentCut";

const specialtyPricing = [
  {
    icon: <HomeIcon />,
    title: "Home Textile Care",

    services: [
      { name: "Curtains & Drapes", price: "From $30.95" },
      { name: "Comforters", price: "From $47.95" },
      { name: "Bed Linens", price: "From $18.95" },
      { name: "Blankets", price: "Quote" },
    ],
  },

  {
    icon: <WeekendIcon />,
    title: "Rug Cleaning",

    services: [
      { name: "Area Rugs", price: "Quote" },
      { name: "Deep Cleaning", price: "Quote" },
      { name: "Stain Removal", price: "Quote" },
      { name: "Odour Treatment", price: "Quote" },
    ],
  },

  {
    icon: <AutoAwesomeIcon />,
    title: "Leather & Fur Care",

    services: [
      { name: "Leather Garments", price: "Quote" },
      { name: "Suede Cleaning", price: "Quote" },
      { name: "Fur Cleaning", price: "Quote" },
      { name: "Inspection Required", price: "Free" },
    ],
  },

  {
    icon: <ContentCutIcon />,
    title: "Alterations & Repairs",

    services: [
      { name: "Hemming", price: "$9.95" },
      { name: "Garment Alterations", price: "Quote" },
      { name: "Handbag Repair", price: "Quote" },
      { name: "Shoe Repair", price: "Quote" },
    ],
  },
];

export default function SpecialtyPricingSection() {
  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        overflow: "hidden",

        backgroundImage: {
          xs: `url(${specialtyBgm})`,
          md: `url(${specialtyBg})`,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",
      }}
    >
      <Container maxWidth="xl">
        {/* HEADING */}

        <Box
          sx={{
            textAlign: "center",

            maxWidth: "850px",

            mx: "auto",
          }}
        >
          <Box
            sx={{
              display: "inline-flex",

              px: 2.5,

              py: 1,

              borderRadius: "50px",

              background: "rgba(0,87,255,.08)",

              color: "#0057FF",

              fontSize: "12px",

              fontWeight: 800,

              letterSpacing: "1px",

              textTransform: "uppercase",
            }}
          >
            Specialty Pricing
          </Box>

          <Typography
            sx={{
              mt: 1.5,

              fontWeight: 900,

              lineHeight: 1.1,

              color: "#07122F",

              fontSize: {
                xs: "32px",
                sm: "32px",
                md: "56px",
                lg: "56px",
              },
              display: "block",
            }}
          >
            Specialty Care {" "}
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                WebkitBackgroundClip: "text",

                WebkitTextFillColor: "transparent",
              }}
            >
              Service Rates
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 2,

              maxWidth: "700px",

              mx: "auto",

              color: "#64748B",

              lineHeight: 1.8,

              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "16px",
              },
            }}
          >
            Expert care for household items, luxury materials and custom apparel
            printing services.
          </Typography>
        </Box>

        {/* CARDS */}

        <Box
          sx={{
            mt: {
              xs: 5,
              md: 8,
            },

            display: "flex",

            flexWrap: "wrap",

            justifyContent: "center",

            gap: 2,
          }}
        >
          {specialtyPricing.map((item, index) => (
            <Box
              key={index}
              sx={{
                flex: {
                  xs: "0 0 calc(50% - 8px)",
                  lg: "0 0 calc(25% - 15px)",
                },

                maxWidth: {
                  xs: "calc(50% - 8px)",
                  lg: "calc(25% - 15px)",
                },

                p: {
                  xs: 1.5,
                  md: 3,
                },

                position: "relative",

                overflow: "hidden",

                borderRadius: "30px",

                backgroundImage: `
                // linear-gradient(
                // rgba(255,255,255,.95),
                // rgba(248,251,255,.88)
                // ),
                url(${specialtyCardBg})
              `,

                backgroundSize: "cover",

                backgroundPosition: "center",

                border: "1px solid rgba(255,255,255,.75)",

                boxShadow: "0 15px 40px rgba(0,87,255,.08)",

                transition: ".35s",

                "&::before": {
                  content: '""',

                  position: "absolute",

                  left: 0,

                  top: 18,

                  bottom: 18,

                  width: "4px",

                  borderRadius: "20px",

                  background: "linear-gradient(180deg,#0057FF,#1DB6FF)",
                },

                "&:hover": {
                  transform: "translateY(-8px)",

                  boxShadow: "0 25px 60px rgba(0,87,255,.14)",
                },
              }}
            >
              {/* ICON */}

              <Box
                sx={{
                  width: {
                    xs: 48,
                    md: 68,
                  },

                  height: {
                    xs: 48,
                    md: 68,
                  },

                  borderRadius: "20px",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",

                  color: "#fff",

                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  boxShadow: "0 15px 35px rgba(0,87,255,.25)",

                  mb: 2,

                  "& svg": {
                    fontSize: {
                      xs: 24,
                      md: 34,
                    },
                  },
                }}
              >
                {item.icon}
              </Box>

              {/* TITLE */}

              <Typography
                sx={{
                  fontWeight: 800,

                  color: "#07122F",

                  mb: 2,

                  fontSize: {
                    xs: "14px",
                    md: "24px",
                  },
                }}
              >
                {item.title}
              </Typography>

              {/* PRICES */}

              {item.services.map((service, idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",

                    justifyContent: "space-between",

                    alignItems: "center",

                    py: 1,

                    borderBottom: "1px dashed rgba(0,87,255,.12)",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#12305F",

                      fontWeight: 600,

                      fontSize: {
                        xs: "10px",
                        md: "14px",
                      },
                    }}
                  >
                    {service.name}
                  </Typography>

                  <Typography
                    sx={{
                      color: "#0057FF",

                      fontWeight: 800,

                      fontSize: {
                        xs: "10px",
                        md: "15px",
                      },
                    }}
                  >
                    {service.price}
                  </Typography>
                </Box>
              ))}

              <Box
                sx={{
                  position: "absolute",

                  left: 0,

                  right: 0,

                  bottom: 0,

                  height: "4px",

                  background: "linear-gradient(90deg,#0057FF,#1DB6FF)",
                }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}